<div class="container-fluid">
  <h6 class="text"><b>{{product.productTitle}}</b></h6>
  <hr/>
  <div class="row mt-1">
    <div class="col-12 col-sm-12 col-lg-4">
      <img class="rounded" src={{product.image}} width=100% height=170px>
    </div>
    <div class="col-12 col-sm-12 col-lg-8">
      <div class="row">
        <div class="col-12 col-sm-12 col-lg-12">
          <div class="row">
            <div class="col-12 col-sm-12 col-md-6">
              <div class="btn btn-primary p-3 w-100 m-1">
                {{ [product.startsAt, product.endsAt] | bidStatus }}
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6">
              <div class="btn btn-primary p-3 w-100 m-1">
                <img src="https://img.icons8.com/fluent-systems-filled/24/ffffff/rupee.png"
                  style="height: 25px; width: 25px;" /> {{product.auctionAmount}}
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6" (click)="edit(product.pid)">
              <div class="btn btn-success p-3 w-100 m-1">
                EDIT
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6" (click)="delete(product.pid)">
              <div class="btn btn-danger p-3 w-100 m-1">
                DELETE 
              </div>
            </div>
          </div>
          <hr>
        </div>
        <div class="col-12 col-sm-12 col-lg-12" *ngFor="let feature of product.productHiglight | slice:0:4;" style="font-size: smaller;">
          <li><i>{{feature}}</i></li>
        </div>
      </div>
    </div>
  </div>
</div>